var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _vm.shortVideo.length
        ? _c("ShortVideo", {
            attrs: {
              "short-video": _vm.shortVideo,
              "get-uigs": _vm.getShortVideoUigs,
              "get-uigs-play-info": _vm.getShortVideoPlayInfo,
              "show-loading": !_vm.loadingFinished,
            },
          })
        : _c("NoResult"),
      _vm._v(" "),
      _c("Gotop"),
      _vm._v(" "),
      _vm.isSnapShot
        ? _c("div", { staticClass: "snap-shot-query" }, [
            _vm._v("\n    " + _vm._s(_vm.query) + "\n  "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }